import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { HtmlRenderer } from 'shared-components';
import {
  Container,
  CenterSection,
  IconCircle,
  Title,
  TextStack,
  Strong,
  ButtonsRow,
} from './styles'; // <-- use the file above
import { DisbursementsContext } from '../../../contexts/DisbursementsContext';
import { CheckGreenIcon } from '../../../components/Icons';
import { PrimaryButton } from '../style';

function AccountCreated() {
  const intl = useIntl();
  const { clearSession } = useContext(DisbursementsContext);

  return (
    <Container>
      <CenterSection>
        <IconCircle>
          <CheckGreenIcon />
        </IconCircle>

        <div style={{ marginBottom: '2rem' }}>
          <Title>{intl.messages['accountCreated.title']}</Title>
          <TextStack>
            <Strong>
              {intl.messages['accountCreated.message']}{' '}
              <b><HtmlRenderer html={intl.messages['accountCreated.message.bold']} /></b>{' '}
              {intl.messages['accountCreated.message._']}
            </Strong>
          </TextStack>
        </div>

        <ButtonsRow>
          <PrimaryButton
            onClick={async () => {
              await clearSession();
            }}
          >
            {intl.messages['accountCreated.loginButton']}
          </PrimaryButton>
        </ButtonsRow>
      </CenterSection>
    </Container>
  );
}

export default AccountCreated;
